// ESTADOS CIVILES EN LOS QUE EL CLIENTE TIENE PAREJA EN LA FICHA.
//
// Vive aparte y SIN UNA SOLA DEPENDENCIA a proposito: lo importan
// `policyTypes.js`, `marketplaceHousehold.js`, `deskte-full.jsx` y las
// pantallas, y cualquiera de esas cadenas arrastrada al reves rompe las
// pruebas (marketplaceHousehold no puede depender de nada que toque `window`).
//
// POR QUE EXISTE. La ficha guarda al conyuge en sus propias casillas
// (`spouse.*`), pero TODO el CRM decide si esa persona existe mirando el estado
// civil, y lo hacia con un `maritalStatus === "married"` escrito a mano en once
// sitios distintos: `hasCurrentSpouse`, el cotizador del Mercado, la lista del
// hogar, los cumpleanos, el ingreso del hogar, el formulario... y el peor de
// todos, `recalcInsured`, que BORRA `spouse` al guardar cuando el estado civil
// no es "married".
//
// Con eso, una pareja de hecho era imposible de tener: entraba en las casillas
// del conyuge y desaparecia de la pantalla, y al primer guardado se borraba de
// la base. Por eso los importadores escribian "casado" a la fuerza para que se
// viera (ImportView, 2026-09-08) — inventando un dato civil que nadie dijo.
//
// Regla: nada vuelve a comparar el estado civil con "married" a mano. Se
// pregunta aqui.
// (Lissette, 2026-09-15, la importacion de la agencia de Denisse: *"varios
// spouse o partner se fueron como spouse pero al espacio de dependiente y no
// de spouse como tal"*.)

/**
 * Los dos estados civiles en los que la ficha CONSERVA a la pareja.
 *
 * Son los dos que trae el enum del backend (MARITAL_STATUSES en
 * clients.routes.ts) que hablan de una pareja viva: casado/a y union libre.
 * "separated" NO esta: el CRM ya la trataba como sin conyuge y cambiarlo ahora
 * haria reaparecer a un ex en las polizas de quien se separo.
 */
export const ESTADOS_CIVILES_CON_PAREJA = ['married', 'domestic_partner'];

/** ¿Este estado civil conserva a la pareja en la ficha? */
export function tienePareja(estadoCivil) {
  return ESTADOS_CIVILES_CON_PAREJA.includes(String(estadoCivil == null ? '' : estadoCivil).trim());
}

/**
 * El estado civil con el que hay que guardar a una pareja que ACABA de entrar
 * en las casillas del conyuge (una importacion, una solicitud publica, el boton
 * "pasar a conyuge").
 *
 * Existe porque escribir la pareja sin arreglar el estado civil es escribirla
 * para nada: `tienePareja` la esconde de todas las pantallas y `recalcInsured`
 * la borra en el siguiente guardado. Si se pone a la persona, se pone tambien
 * el estado que la conserva.
 *
 * - Si el archivo ya trae un estado CON pareja, se respeta tal cual (no se
 *   convierte un "casado" en "union libre" ni al contrario).
 * - Si no, se escribe `domestic_partner` cuando la relacion decia *pareja* y
 *   `married` cuando decia *conyuge*. Un "soltero" con conyuge en la misma fila
 *   es un dato que se contradice: se conserva a la PERSONA, que es la que no se
 *   puede recuperar despues, y el estado civil se corrige con un clic.
 */
export function estadoCivilParaConservarPareja(estadoCivilActual, esDeHecho) {
  if (tienePareja(estadoCivilActual)) return String(estadoCivilActual).trim();
  return esDeHecho ? 'domestic_partner' : 'married';
}
